module.exports = __webpack_public_path__ + "static/media/IMG-18.c6e62115.jpg";